import { render, staticRenderFns } from "./dropCarousel.vue?vue&type=template&id=907314dc&scoped=true"
import script from "./dropCarousel.vue?vue&type=script&lang=js"
export * from "./dropCarousel.vue?vue&type=script&lang=js"
import style0 from "./dropCarousel.vue?vue&type=style&index=0&id=907314dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "907314dc",
  null
  
)

export default component.exports